import { Renderer2, ElementRef, OnDestroy, ViewChild, Directive, Injector } from '@angular/core';
import { ControlValueAccessorValidatorBase } from '@fi-shared/control-value-accessor-validator-base';
import { Subject } from 'rxjs';
import { eventFindInPath } from '@fi-shared/utils';

@Directive()
export class DropdownBase extends ControlValueAccessorValidatorBase<any> implements OnDestroy {
    public isDropdownOpened: boolean = false;
    protected documentListener: any;

    @ViewChild('dropdownElement', { static: false }) dropdownElement: ElementRef;

    constructor(
        injector: Injector,
        protected renderer: Renderer2,
        protected elementRef: ElementRef,
    ) {
        super(injector);
    }

    ngOnDestroy$ = new Subject<void>();
    ngOnDestroy(): void {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
        if (this.documentListener) this.documentListener();
    }

    public updateOpenClass() {
        this.dropdownElement.nativeElement.classList.toggle('open', this.isDropdownOpened);
    }

    public openDropdown() {
        this.isDropdownOpened = true;
        this.updateOpenClass();

        // close dropdown by clicking outside or by clicking on item
        if (this.documentListener) this.documentListener();

        this.documentListener = this.renderer.listen('document', 'click', (event) => {
            if (
                event.target.tagName !== 'BODY' &&
                !event.target.classList.contains('loading') &&
                !this.elementRef.nativeElement.contains(event.target) &&
                !this.isClickOnItem(event)
            )
                this.closeDropdown();
        });
    }

    private isClickOnItem(event) {
        return this.isItemClickCloseIgnored && eventFindInPath(event, '.fi-dropdown-items');
    }

    private isItemClickCloseIgnored = false;
    public setIgnoreCloseOnItemClick() {
        this.isItemClickCloseIgnored = true;
    }

    public closeDropdown() {
        this.isDropdownOpened = false;
        this.updateOpenClass();
        if (this.documentListener) this.documentListener();
    }
}
